export default "__VITE_ASSET__BHi8QS6D__"